import {  } from '@/api/api';
import { createRouter } from '../../router'
export default {
  namespaced: true,
  state: {
    SEO:{
      title: ' | LuckScore',
      keywords: '',
      description: ''
    },
  },
  mutations: {
    
  },
  actions: {
    
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/newsInfo.js